import React from 'react';
import { Box } from '@mui/material';

interface Props {
    sx?: Object,
};

const Logo: React.FC<Props> = ({ sx }) => {
    return <Box component="img" src="/static/logo.png" sx={{ width: 120, height: 45, ...sx }} />;
}

export default Logo;